export default __webpack_public_path__ + "static/media/s-21.75aca713.svg";